import withAPIAction from 'helpers/withAPIAction'
import {
  AdvertiseListReq,
  CreateAdvertiseReq,
  UpdateAdvertiseReq,
  DeleteAdvertiseReq,
  AdvertiseDetailReq,
} from './types'
import {
  getAdvertiseListAction,
  createAdvertiseAction,
  updateAdvertiseAction,
  deleteAdvertiseAction,
  getAdvertiseDetailAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const advertiseListAPI = (data: AdvertiseListReq, token: string) => {
  return withAPIAction<AdvertiseListReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.advertiseList}?${getRequestString(data)}`,
    data,
    token,
  })(getAdvertiseListAction)
}

export const createAdvertiseAPI = (data: CreateAdvertiseReq, token: string) => {
  return withAPIAction<CreateAdvertiseReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createAdvertise,
    data,
    token,
  })(createAdvertiseAction)
}

export const updateAdvertiseAPI = (data: UpdateAdvertiseReq, token: string) => {
  const endPoint = APIPath.deleteAdvertise.replace(':id', data.id.toString())
  return withAPIAction<UpdateAdvertiseReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(updateAdvertiseAction)
}

export const deleteAdvertiseAPI = (data: DeleteAdvertiseReq, token: string) => {
  const endPoint = APIPath.deleteAdvertise.replace(':id', data.id.toString())
  return withAPIAction<DeleteAdvertiseReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(deleteAdvertiseAction)
}

export const getAdvertiseDetailAPI = (data: AdvertiseDetailReq, token: string) => {
  const endPoint = APIPath.getAdvertiseByID.replace(':id', data.id.toString())
  return withAPIAction<AdvertiseDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(getAdvertiseDetailAction)
}
